import React, {useState, useEffect} from 'react';
import { useQuery, useLazyQuery, useMutation } from '@apollo/client';
import {
  TAGS_WITH_COUNT
} from './queries';
import { View, Text, Pressable } from 'react-native';
import styled from 'styled-components/native';
import {
  MainContainer,
  ContentContainer
} from 'app/src/elements';
import Input from '../../elements/inputs';
import { Button, ButtonGroup, ButtonContainer } from 'app/src/elements/buttons';
import { elGray } from '../../styles/colors';

const AssignTags = (props) => {
  const { tagOptions, selectedTags, setSelectedTags, blogId } = props;
  const [tags, setTags] = useState(tagOptions || []);

  const [ loadTags, { loading: tagsLoading, data: tagData } ] =
    useLazyQuery(TAGS_WITH_COUNT, {});

  useEffect(() => {
    if(!tagOptions) {
      loadTags();
    }
  }, [])
  useEffect(() => {
    if(tagData) {
      setTags(tagData.tagsWithCount.entries)
    }
  }, [tagData])

  // const onSubmit = () => {
  //   updateAsset({ variables: {
  //     id: assetId,
  //     userIds: selectedUsers,
  //     sellerUserIds: selectedSellerUsers
  //   }});
  // }

  return (
    <View style={{border: `2px solid ${elGray}`, padding: '10px'}}>
      <Input.MultiSelect
        selected={selectedTags}
        setSelected={setSelectedTags}
        resourceType='Blog Categories'
        resources={tags?.map(tag => {
          return { id: tag.id, name: tag.name}
        })}
      />
      <br />
    </View>
  )
}

export default AssignTags;
